import { PLACEMENT_DISPLAY_CONTENT } from 'modules/placements/constants';
import { EmptyStateEmbedded } from 'ui/illustrations';
import { H4 } from 'ui/theme';
import { EmptyStateContainer, EmptyStateSecondaryText } from './styles';

const { headerText, bodyText } = PLACEMENT_DISPLAY_CONTENT.missingPermission;

export const PlacementsMissingPermissionState = () => {
  return (
    <EmptyStateContainer data-test="placements-missing-permission-state">
      <EmptyStateEmbedded />
      <H4>{headerText}</H4>
      <EmptyStateSecondaryText>{bodyText}</EmptyStateSecondaryText>
    </EmptyStateContainer>
  );
};
